
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"25","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"clip-path":"url(#clip0_2176_20836)","fill":"#fff"}},[_c('path',{attrs:{"d":"M4.5 3a1 1 0 000 2h16a1 1 0 100-2h-16zM19.5 8a1 1 0 10-2 0v10a1 1 0 01-1 1h-8a1 1 0 01-1-1V8a1 1 0 10-2 0v10a3 3 0 003 3h8a3 3 0 003-3V8z"}}),_c('path',{attrs:{"d":"M10.5 9a1 1 0 011 1v6a1 1 0 11-2 0v-6a1 1 0 011-1zM15.5 10a1 1 0 10-2 0v6a1 1 0 102 0v-6z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_2176_20836"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(.5)","d":"M0 0h24v24H0z"}})])])]);
        };
      

        module.exports = {
          
          render: render,
        };
      